import React from 'react';

import {
  useOAIMutation,
  useOAIQuery,
  useSyncStorageEffect,
} from '~/hooks/reactQuery';
import { fetchOAIData } from '~/libs/openapi';
import type { OAISchema } from '~/types/openapi';

import { getSnowdonJwt } from '../auth/utils';

export const useFetchShippingAddress = () => {
  const { data } = useOAIQuery({
    queryKey: '/api/market-place/v1/shipping-address',
  });

  return data || [];
};

export const useDefaultShippingAddress = (
  // TODO: useOAIQuery type 때문에 모든 queryOptions를 typing을 제대로 할 수가 없어서
  // 우선 정말 필요한 options만 parameter로 받을 수 있도록 수정 나중에 좋은 방법이 생각나면 수정
  queryOptions?: { enabled?: boolean; useErrorBoundary?: boolean },
) => {
  const { data } = useOAIQuery({
    queryOptions,
    queryKey: '/api/market-place/v1/shipping-address/default',
  });

  return data?.hasAddress ? data : null;
};

export async function fetchDefaultShippingAddress() {
  const data = await fetchOAIData<OAISchema['MarketShippingAddressResponse']>({
    queryKey: '/api/market-place/v1/shipping-address/default',
    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': getSnowdonJwt(),
      },
    },
  });

  return !!data?.hasAddress;
}

export const useDeleteShippingAddress = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'delete',
    mutationKey: '/api/market-place/v1/shipping-address',
  });
  return mutateAsync;
};

export const useChangeDefaultShippingAddress = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'patch',
    mutationKey: '/api/market-place/v1/shipping-address/default-change',
  });

  return mutateAsync;
};

export const useRegisterShippingAddress = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'post',
    mutationKey: '/api/market-place/v2/shipping-address',
  });
  return mutateAsync;
};

export const useUpdateShippingAddress = () => {
  const { mutateAsync } = useOAIMutation({
    method: 'put',
    mutationKey: '/api/market-place/v1/shipping-address',
  });
  return mutateAsync;
};

export const useAddressTooltipMessage = () => {
  const timerRef = React.useRef<NodeJS.Timeout>();
  const [tooltipMessage, setTooltipMessage] = React.useState<string>();

  useSyncStorageEffect(() => {
    setTooltipMessage('배송지가 변경되었습니다');
    timerRef.current = setTimeout(() => setTooltipMessage(''), 2000);
  }, 'NOTIFY_CHANGE_DEFAULT_ADDRESS');

  useSyncStorageEffect(() => {
    setTooltipMessage('새 배송지가 추가되었습니다');
    timerRef.current = setTimeout(() => setTooltipMessage(''), 2000);
  }, 'NOTIFY_ADD_NEW_ADDRESS');

  React.useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return tooltipMessage;
};

export const useAddressTerm = () =>
  useOAIQuery({
    queryKey: '/api/market-place/v2/terms/address',
  });
